<template>
  <div
    class="container"
    :class="{ containerRJI: nomeEmpresa == 'RJI' || nomeEmpresa == 'ACTUAL' }"
  >
    <div class="left-side">
      <div class="form-container form-cadastro">
        <h2>Cadastre-se</h2>
        <img
          src="@/assets/progressoCadastro2.png"
          alt="Logo"
          class="logoProgresso"
          v-if="nomeEmpresa != 'RJI' && nomeEmpresa != 'ACTUAL'"
        />
        <img
          src="@/assets/progressoCadastro2_rji.png"
          alt="Logo"
          class="logoProgresso"
          v-if="nomeEmpresa == 'RJI' && nomeEmpresa == 'ACTUAL'"
        />
        <form>
          <label for="senha">Senha*</label>
          <input
            type="password"
            v-model="cadastro.senha"
            id="senha"
            placeholder="Crie uma senha"
          />
          <div>
            <p>
              Mínimo de 8 caracteres, sendo ao menos 1 letra maiúscula, 1
              minúscula e 1 caractere especial.
            </p>
          </div>
          <label for="confirmarSenha">Confirmar senha*</label>
          <input
            type="password"
            v-model="cadastro.confirmarSenha"
            id="confirmarSenha"
            placeholder="Digite novamente"
          />
          <button
            type="button"
            class="submit-button"
            @click="createAccount()"
            :disabled="disableBtnLogin"
            :class="{ disabledBtn: disableBtnLogin }"
          >
            <span class="btnText" v-if="!disableBtnLogin">Criar conta</span>
            <div class="loadingDots" v-if="disableBtnLogin">
              <span class="dot">.</span>
              <span class="dot2">.</span>
              <span class="dot3">.</span>
            </div>
          </button>
          <button
            type="button"
            class="submit-button white-button"
            @click="voltar()"
          >
            Voltar
          </button>
        </form>
        <div class="footer">
          <p>
            Já possui uma conta? <router-link to="/login">Entrar</router-link>
          </p>
        </div>
      </div>
    </div>
    <div class="right-side">
      <div
        v-for="(bg, index) in bgImages"
        :key="index"
        class="bg-slide"
        :class="{ active: currentBgIndex === index }"
        :style="{
          backgroundImage: `linear-gradient(135deg, rgba(26, 35, 50, 0.55) 0%, rgba(26, 35, 50, 0.3) 35%, rgba(20, 20, 20, 0.75) 70%, rgba(10, 10, 10, 0.95) 100%), url(${bg})`,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapGetters } from "vuex";
import SHA256 from "crypto-js/sha256";

export default {
  name: "CadastroFinalizacao",
  computed: {
    ...mapGetters({
      account: "GET_CREATE_ACCOUNT",
    }),
  },
  data() {
    return {
      nomeEmpresa: "",
      cadastro: {
        senha: null,
        confirmarSenha: null,
      },
      disableBtnLogin: false,
      permitirAvancar: false,
      currentBgIndex: 0,
      bgImages: [
        require("@/assets/carmelCapital/fundo1.png"),
        require("@/assets/carmelCapital/fundo2.jpg"),
        require("@/assets/carmelCapital/fundo3.png"),
        require("@/assets/carmelCapital/fundo4.png"),
        require("@/assets/carmelCapital/fundo5.png"),
      ],
      bgTransitionTimer: null,
    };
  },
  mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.disableBtnLogin = false;

    this.bgTransitionTimer = setInterval(() => {
      this.currentBgIndex = (this.currentBgIndex + 1) % this.bgImages.length;
    }, 7000);
  },
  beforeUnmount() {
    if (this.bgTransitionTimer) {
      clearInterval(this.bgTransitionTimer);
    }
  },
  methods: {
    limparCadastro() {
      this.cadastro.senha = null;
      this.cadastro.confirmarSenha = null;
    },
    validarConcluirCadastro() {
      if (this.cadastro.senha == null || this.cadastro.senha == "") {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: `Necessário preencher a senha`,
        });
        return false;
      }
      if (this.cadastro.senha != this.cadastro.confirmarSenha) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: `Senha e confirmação de senha precisam ser iguais`,
        });
        return false;
      }
      return true;
    },
    validarSenha(senha) {
      if (!senha) return false;

      const temLetraMaiuscula = /[A-Z]/.test(senha);
      const temLetraMinuscula = /[a-z]/.test(senha);
      const temNumero = /[0-9]/.test(senha);
      const tamanhoMinimo = senha.length >= 8;

      return (
        temLetraMaiuscula && temLetraMinuscula && temNumero && tamanhoMinimo
      );
    },
    async createAccount() {
      this.disableBtnLogin = true;
      if (!this.validarConcluirCadastro()) {
        this.disableBtnLogin = false;
        return;
      }
      if (this.cadastro == null) {
        this.disableBtnLogin = false;
        return;
      }
      if (this.cadastro.senha != this.cadastro.confirmarSenha) {
        this.disableBtnLogin = false;
        return;
      }

      if (!this.validarSenha(this.cadastro.senha)) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: `Senha informada não atende aos critérios. É necessário possuir o mínimo de 8 caracteres, sendo ao menos 1 letra maiúscula, 1 minúscula e 1 caractere especial.`,
        });
        this.disableBtnLogin = false;
        return;
      }

      var cadastroFinal = {
        TipoCadastro: this.account.selectedTipoCliente,
        NomeRazaoSocial: this.account.nomeRazaoSocial,
        CpfCnpj:
          this.account.selectedTipoCliente == "1"
            ? this.account.cpf
            : this.account.cnpj,
        Email: this.account.email,
        Password: SHA256(this.cadastro.senha).toString(),
        Apelido: this.account.apelido,
        DataConstituicao: this.account.dataConstituicao,
      };
      await api
        .post("/register", cadastroFinal)
        .then((retorno) => {
          this.disableBtnLogin = false;
          if (!retorno.data) {
            if (
              typeof retorno.data[0] === "string" &&
              retorno.data[0].includes("Password")
            ) {
              this.$swal({
                icon: "error",
                title: "Oops...",
                text: `Senha informada não atende aos critérios. É necessário possuir o mínimo de 8 caracteres, sendo ao menos 1 letra maiúscula, 1 minúscula e 1 caractere especial.`,
              });
            } else {
              this.$swal({
                icon: "error",
                title: "Oops...",
                text: `Falha na criação da conta`,
              });
            }
          } else {
            this.$store.commit("SET_CREATE_ACCOUNT", []);
            this.limparCadastro();
            this.$store.commit("SET_MODAL_ADESAO", true);
            this.$swal({
              icon: "success",
              title: "Cadastro realizado!",
              text: `Acesse o e-mail cadastrado para confirmar seu acesso.`,
            }).then((result) => {
              if (result.value) {
                this.$router.push({
                  path: "/login",
                });
              }
            });
          }
        })
        .catch((error) => {
          this.disableBtn = false;
          this.disableBtnLogin = false;
          if (
            error.response.data.data[0] ==
            "Password: Verifique o padrão da senha"
          ) {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: `Senha informada não atende aos critérios. É necessário possuir o mínimo de 8 caracteres, sendo ao menos 1 letra maiúscula, 1 minúscula e 1 caractere especial.`,
            });
          } else {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: `${error.response.data.descricao}`,
            });
          }
        });
    },
    voltar() {
      this.$router.replace({ name: "CadastroInicio" });
    },
  },
  // watch: {
  //     // consultarPermissaoAvancar() {
  //     //     this.permitirAvancar = false;
  //     //     if (this.cadastro.selectedTipoCliente == 'PF') {
  //     //         // Para Pessoa Física, nome completo e CPF são obrigatórios
  //     //         if (this.cadastro.nomeCompleto && this.cadastro.nomeCompleto.length > 5 && this.validarCPF(this.cadastro.CPF)) {
  //     //             this.permitirAvancar = true;
  //     //         }
  //     //     } else if (this.cadastro.selectedTipoCliente == 'PJ' || this.cadastro.selectedTipoCliente == 'FU') {
  //     //         // Para Pessoa Jurídica ou Funcionário, razão social e CNPJ são obrigatórios
  //     //         if (this.cadastro.razaoSocial && this.cadastro.CNPJ && this.validarCNPJ(this.cadastro.CNPJ)) {
  //     //             this.permitirAvancar = true;
  //     //         }
  //     //     }
  //     // }
  // }
};
</script>

<style scoped>
.container {
  display: flex;
  min-height: 100vh;
  /* Viewport height */
  overflow: hidden;
  /* Isso pode ajudar a impedir o scroll indesejado */
}

.logoProgresso {
  width: 380px;
  height: 10px;
}

h2 {
  font-family: "Gabarito", sans-serif;
  font-weight: 600;
  /* Semibold */
  font-size: 30px;
  line-height: 38px;
  color: #101828;
  /* Gray/900 */
}

.right-side {
  width: 50%;
  position: relative;
  overflow: hidden;
}

.bg-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: left center;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 1.5s ease-in-out;
}

.bg-slide.active {
  opacity: 1;
}

.rightSideGenial {
  width: 50%;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("@/assets/fundoGenialCadastro.png") !important;
  background-size: cover;
  overflow: hidden;
  /* Isso impedirá que o conteúdo excedente cause scroll */
}

.rightSideRJI {
  width: 50%;
  background: linear-gradient(rgba(15, 37, 71, 0.5), rgba(15, 37, 71, 0.5)),
    url("@/assets/fundoRJI.png") !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  overflow: hidden;
  /* Isso impedirá que o conteúdo excedente cause scroll */
}

.rightSideActual {
  width: 50%;
  background: url("@/assets/fundo_actual_secundario.png") !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  overflow: hidden;
  /* Isso impedirá que o conteúdo excedente cause scroll */
}

/* Aplicando estilos de fonte */
button {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
}

input,
select {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px;
  margin-bottom: 16px;
  /* Ajuste para a linha de altura */
  border: 1px solid #ccc;
  border-radius: 8px;
  /* Arredondamento dos inputs */
  box-sizing: border-box;
  /* Garante que o padding não adicione largura extra */
  width: 100%;
  /* Para garantir que os inputs ocupem toda a largura do container */
}

/* Estilos para os rótulos (labels) do formulário */
form label {
  font-family: "Inter", sans-serif;
  /* Família da fonte Inter */
  font-weight: 500;
  /* Peso médio da fonte */
  font-size: 14px;
  /* Tamanho da fonte */
  line-height: 20px;
  /* Altura da linha */
  color: #344054;
  /* Cor do texto em cinza escuro */
}

.footer {
  text-align: center;
}

.footer p {
  font-family: "Inter", sans-serif;
  color: #667085;
  /* Este é um cinza genérico, ajuste conforme necessário */
  font-size: 16px;
  /* Exemplo de tamanho de fonte, ajuste conforme necessário */
  line-height: 24px;
  /* Exemplo de altura de linha, ajuste conforme necessário */
}

.containerRJI {
  background-color: rgba(15, 37, 71, 1) !important;
  color: #fff;
}

.containerRJI h2 {
  color: #fff !important;
}

.containerRJI p {
  color: #fff !important;
}

.containerRJI label {
  color: #fff !important;
}

.containerRJI a {
  color: #fff !important;
  font-weight: 800;
}

form p {
  font-family: "Inter", sans-serif;
  color: #667085;
  /* Este é um cinza genérico, ajuste conforme necessário */
  font-size: 16px;
  /* Exemplo de tamanho de fonte, ajuste conforme necessário */
  line-height: 24px;
  /* Exemplo de altura de linha, ajuste conforme necessário */
  margin-top: -5px;
  font-size: 14px;
  font-weight: 400;
}

.footer a {
  font-weight: 600;
  /* Para 'Cadastre-se', que parece ser mais destacado */
  color: #101828;
  /* Este é o azul padrão de links, ajuste conforme necessário */
  text-decoration: none;
  /* Para sublinhar o link */
}

/* Estilos para o formulário */
form {
  display: flex;
  flex-direction: column;
}

/* Estilos para os inputs */
input {
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.left-side {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
}

.form-container {
  max-width: 400px;
  margin: 0 auto;
}

input,
select {
  width: 100%;
  padding: 0.5rem;
  margin: 0.5rem 0;
  border: 1px solid #ccc;
}

.submit-button {
  width: 100%;
  padding: 0.5rem;
  margin-top: 1rem;
  color: white;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(46, 204, 113, 0.35),
    0 2px 6px rgba(46, 204, 113, 0.25);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.submit-button:hover {
  background: linear-gradient(135deg, #3ddc84 0%, #2ecc71 100%);
  box-shadow: 0 6px 20px rgba(46, 204, 113, 0.45),
    0 3px 10px rgba(46, 204, 113, 0.35);
  transform: translateY(-2px);
}

.white-button {
  background: white;
  color: #101828;
  border: 1px solid #101828;
}

/* Responsividade */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }
  .left-side,
  .right-side {
    width: 100%;
  }

  .right-side {
    background-size: contain;
    /* ou você pode tentar 100% 100% para forçar a cobertura completa */
    height: auto;
    /* ajuste a altura para manter a proporção da imagem */
  }
}
</style>
